<script setup>
import PaginationInfo from './PaginationInfo.vue';
import PaginatorControls from './PaginatorControls.vue';

// 1. Recebe todas as props necessárias
defineProps({
  currentPage: { type: Number, required: true },
  pageSize: { type: Number, required: true },
  totalCount: { type: Number, required: true },
  totalPages: { type: Number, required: true },
});

// 2. Propaga o evento 'change-page' para o componente pai
const emit = defineEmits(["change-page"]);

function handleChangePage(page) {
  emit('change-page', page);
}
</script>

<template>
  <div class="pagination-container">
    <PaginationInfo
      :current-page="currentPage"
      :page-size="pageSize"
      :total-count="totalCount"
    />
    <PaginatorControls
      :current-page="currentPage"
      :total-pages="totalPages"
      @change-page="handleChangePage"
    />
  </div>
</template>

<style scoped>
/* =========================
   Alinhar dimensões com PaginationButtons.vue (tight)
   - NÃO altera lógica/template
   - só tipografia e espaçamento
   ========================= */

.pagination-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;

    /* base igual ao PaginationButtons */
  font-size: 0.82rem;
  line-height: 1.15;
  color: var(--text-light);
}

/* -------- PaginationInfo.vue -------- */
.pagination-container :deep(.pagination-info) {
  font-size: 0.82rem;   /* era 0.875rem */
  line-height: 1.15;
  color: var(--text-light); /* substitui #6c757d para harmonizar */
}

/* -------- PaginatorControls.vue -------- */
.pagination-container :deep(.paginator) {
  display: flex;
  align-items: center;
  gap: 3px; /* era 4px */
}

.pagination-container :deep(.page-btn) {
  border: 1px solid var(--border-color);
  background: var(--surface);

  color: var(--text-light);
  border-radius: 10px; /* era 8px */

  height: 26px;        /* era 32px */
  min-width: 26px;     /* era 32px */
  padding: 0 8px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  font-weight: 600;    /* era 500 */
  font-size: 0.65rem;  /* antes herdava maior */
  line-height: 1;

  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease, transform 0.05s ease;
}

.pagination-container :deep(.page-btn:hover) {
  background-color: var(--neutral-100);
  color: var(--text-dark);
}

.pagination-container :deep(.page-btn:active) {
  transform: translateY(1px);
}

.pagination-container :deep(.page-btn:disabled) {
  cursor: not-allowed;
  opacity: 0.5;
}

.pagination-container :deep(.page-btn.active) {
  background-color: var(--bg-active-nav); /* era #f9ded7 */
  border-color: transparent;
  color: var(--text-dark);
  font-weight: 700; /* era 600 */
}

.pagination-container :deep(.page-btn-ellipsis) {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  height: 26px;     /* era 32px */
  padding: 0 6px;   /* era 0 8px */
  color: var(--text-light);

  font-size: 0.82rem;
  line-height: 1;
}

/* ícones dentro do botão (chevrons) proporcionais ao novo botão */
.pagination-container :deep(.page-btn i) {
  font-size: 0.75rem;
  line-height: 1;
}
</style>
